import React from "react";
import { useStores } from "_common/hooks";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import icon12 from "assets/img/member/icon12.svg";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function Introduction() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title={i18next.t("introduction")} />
      <div className="flex flex-col justify-center items-center pt-8 pb-4 bg-[#1c1c1e]">
        <div className="p-2 bg-[#10172a] mb-2">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/about.svg"
            width="100"
            height="100"
            alt="About"
            className="w-[98px] h-[98px]"
          />
        </div>
        <h3 className="text-lg text-white">EUREX</h3>
        <span className="text-md text-[#888]">Phiên bản 1.39.2</span>
      </div>
      <div className="flex items-center gap-2 p-4 cursor-pointer">
        <img src={icon12} className="w-[20px]" alt="" />
        <span className="flex-1 text-base text-white">
          {i18next.t("note47")}
        </span>
        <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
      </div>
    </div>
  );
}
